export const COLORS = {
  primary: "#16596b",
  accent: "#f8da76",
  accentDark: "#c4ac5a",
  amazonColor: "#FF9900",
  amazonDarkColor: "#db8400",
};
